import { api } from "../base";
import type { ILedgerShadowResponse } from "@pulse-ui/codegen-v2/generated_ts/ledger_shadow";

export {
  LedgerShadowBucket,
  LedgerShadowSource,
  type ILedgerShadowResponse,
  type ILedgerShadowBkFlow,
  type ILedgerShadowCensus,
  type ILedgerShadowFinding,
  type ILedgerShadowHealth,
  type ILedgerShadowResolvedFinding,
  type ILedgerShadowStreamWatch,
  type ILedgerShadowWatch,
} from "@pulse-ui/codegen-v2/generated_ts/ledger_shadow";

// Served by risk-server GET /api/risk/v1/ledger-shadow; Risk or Admin only.
const ledgerShadowEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getLedgerShadow: build.query<ILedgerShadowResponse, void>({
      query: () => ({
        url: "/api/risk/v1/ledger-shadow",
      }),
    }),
  }),
});

export const { useGetLedgerShadowQuery } = ledgerShadowEndpoints;
